<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="disabled" [multiple]="multiple"
           [placeholder]="'hx.city-select.selectCity' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.id">{{op.title | uiLabel}}</ng-option>
</ng-select>
